import { useCallback, useState, useEffect } from 'react';

// Simple store for report selection (works across components without context)
let selectedReports = [];
const listeners = new Set();

function emitChange() {
  listeners.forEach((listener) => listener());
}

export const reportSelectionStore = {
  subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  getSnapshot() {
    return selectedReports;
  },
  toggleReport(report) {
    const exists = selectedReports.find((r) => r._id === report._id);
    if (exists) {
      selectedReports = selectedReports.filter((r) => r._id !== report._id);
    } else {
      selectedReports = [...selectedReports, report];
    }
    emitChange();
  },
  selectAll(reports) {
    selectedReports = [...reports];
    emitChange();
  },
  clearSelection() {
    selectedReports = [];
    emitChange();
  },
  isSelected(reportId) {
    return selectedReports.some((r) => r._id === reportId);
  },
};

// Hook to use the selection store
export function useReportSelection() {
  const [selected, setSelected] = useState(reportSelectionStore.getSnapshot());

  useEffect(() => {
    const unsubscribe = reportSelectionStore.subscribe(() => {
      setSelected(reportSelectionStore.getSnapshot());
    });
    return unsubscribe;
  }, []);

  const toggleReport = useCallback((report) => {
    reportSelectionStore.toggleReport(report);
  }, []);

  const selectAll = useCallback((reports) => {
    reportSelectionStore.selectAll(reports);
  }, []);

  const clearSelection = useCallback(() => {
    reportSelectionStore.clearSelection();
  }, []);

  const isSelected = useCallback(
    (reportId) => selected.some((r) => r._id === reportId),
    [selected]
  );

  return {
    selectedReports: selected,
    toggleReport,
    selectAll,
    clearSelection,
    isSelected,
  };
}

export default reportSelectionStore;
